var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('exception-message-modal',{attrs:{"isVisible":_vm.exception,"message":_vm.exceptionMessage}}),_c('logout-notification-modal',{attrs:{"isVisible":_vm.isLoggingOut,"message":"Logout"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }